import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DaySlot } from '../components/FOVScheduling/FOVScheduling.types';

export interface FOVSchedulingState {
  availableDays: DaySlot[];
  ePrId: string | null;
  redirectUrl: string | null;
  timezone: string | null;
  /** Whether the last GetAvailableSlots pre-fetch (on card switch) returned slots. */
  hasSlots: boolean;
}

const initialState: FOVSchedulingState = {
  availableDays: [],
  ePrId: null,
  redirectUrl: null,
  timezone: null,
  hasSlots: false,
};

const fovSchedulingSlice = createSlice({
  name: 'fovScheduling',
  initialState,
  reducers: {
    setAvailableDays(state, action: PayloadAction<DaySlot[]>) {
      state.availableDays = action.payload;
    },
    setFOVEPrId(state, action: PayloadAction<string | null>) {
      state.ePrId = action.payload;
    },
    setFOVRedirectUrl(state, action: PayloadAction<string | null>) {
      state.redirectUrl = action.payload;
    },
    setFOVTimezone(state, action: PayloadAction<string | null>) {
      state.timezone = action.payload;
    },
    setFOVHasSlots(state, action: PayloadAction<boolean>) {
      state.hasSlots = action.payload;
    },
    clearFOVScheduling() {
      return initialState;
    },
  },
});

export const {
  setAvailableDays,
  setFOVEPrId,
  setFOVRedirectUrl,
  setFOVTimezone,
  setFOVHasSlots,
  clearFOVScheduling,
} = fovSchedulingSlice.actions;

export default fovSchedulingSlice.reducer;
